module.exports = __webpack_public_path__ + "static/media/available_on_the_app_store_badge.1015cab7.png";